import {TApiResponseModel} from '../../typings/models/common/t-api-response-model';
import {TPaginationResponseModel} from '../../typings/models/common/t-pagination.model';

export class TApiResponseModelExtensions<T> {
  private constructor() {}

  static replaceData<T, K>(tApiResponseModel: TApiResponseModel<T>, newData: K): TApiResponseModel<K> {
    let newTApiResponseModel: TApiResponseModel<K> = {
      data: newData,
      success: tApiResponseModel.success,
      errors: tApiResponseModel.errors,
      message: tApiResponseModel.message,
      timestamp: tApiResponseModel.timestamp
    };

    return newTApiResponseModel;
  }

  static replaceListData<T, K >(
    tApiResponseModel: TApiResponseModel<TPaginationResponseModel<T>>,
    newData: K[] | null): TApiResponseModel<TPaginationResponseModel<K>> {
    let newTApiResponseModel: TApiResponseModel<TPaginationResponseModel<K>> = {
      data: {
        items: newData,
        pageNumber: tApiResponseModel.data.pageNumber,
        pageSize: tApiResponseModel.data.pageSize,
        totalItemsCount: tApiResponseModel.data.totalItemsCount,
        totalPages: tApiResponseModel.data.totalPages,
        hasPrevious: tApiResponseModel.data.hasPrevious,
        hasNext: tApiResponseModel.data.hasNext,
      },
      success: tApiResponseModel.success,
      errors: tApiResponseModel.errors,
      message: tApiResponseModel.message,
      timestamp: tApiResponseModel.timestamp
    };

    return newTApiResponseModel;
  }
}
